export default {
  BIM_MASK: "bim_mask",
  MILESTONE: "milestone",
}
